{
  "name": "@papra/cli",
  "type": "module",
  "version": "0.2.3",
  "description": "Command line interface for Papra, the document archiving platform.",
  "author": "Corentin Thomasset <corentinth@proton.me> (https://corentin.tech)",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "https://github.com/papra-hq/papra",
    "directory": "packages/cli"
  },
  "bugs": {
    "url": "https://github.com/papra-hq/papra/issues"
  },
  "keywords": [
    "papra",
    "cli",
    "document",
    "archiving",
    "storage"
  ],
  "exports": {
    ".": "./dist/cli.js",
    "./package.json": "./package.json"
  },
  "main": "./dist/cli.js",
  "module": "./dist/cli.js",
  "types": "./dist/cli.d.ts",
  "bin": {
    "papra": "./bin/papra.mjs"
  },
  "files": [
    "bin",
    "dist"
  ],
  "scripts": {
    "dev": "tsx ./src/cli.ts",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest watch",
    "typecheck": "tsc --noEmit",
    "build": "tsdown",
    "build:watch": "tsdown --watch",
    "prepublishOnly": "pnpm run build"
  },
  "dependencies": {
    "@clack/prompts": "^1.0.0-alpha.6",
    "@corentinth/chisels": "catalog:",
    "@papra/api-sdk": "workspace:*",
    "citty": "^0.1.6",
    "conf": "^13.1.0",
    "jszip": "^3.10.1",
    "mime-types": "^3.0.1",
    "ofetch": "^1.4.1",
    "picocolors": "^1.1.1",
    "valibot": "1.0.0-beta.10"
  },
  "devDependencies": {
    "@antfu/eslint-config": "catalog:",
    "@types/mime-types": "^2.1.4",
    "@types/node": "catalog:",
    "eslint": "catalog:",
    "tsdown": "catalog:",
    "tsx": "catalog:",
    "typescript": "catalog:",
    "vitest": "catalog:"
  }
}
